module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/QRlogoGreen.65ab03128c65bcaba0eaff065d91384f.svg";